import { Box, ListItem, Switch, Typography } from "@material-ui/core";
import React, { useState } from "react";
import CustomDraggableDialog from "../../common/customDialog/CustomDraggableDialog";
import FormGridCell from "../../common/FormGridCell";
import TranslatedMessage from "../../translations/TranslatedMessage";

interface ExamSessionCandidateModuleRebookDialogProps {
  opened: boolean;
  accept: (rebookWithInvoice: boolean) => void;
  decline: () => void;
}

const ExamSessionCandidateModuleRebookDialog: React.FC<ExamSessionCandidateModuleRebookDialogProps> = ({
  opened,
  accept,
  decline,
}) => {
  const [rebookWithInvoice, setRebookWithInvoice] = useState(true);

  const handleAccept = async () => {
        accept(rebookWithInvoice);
  };

  if (!opened) {
    return null;
  }

  return (
    <CustomDraggableDialog
      acceptText={<TranslatedMessage id="common.accept" />}
      cancelText={<TranslatedMessage id="common.cancel" />}
      content={
        <>
          <ListItem>
              <FormGridCell size="wide">
                <Box display="flex" alignItems="center" justifyContent="start">
                  <Typography>
                    <TranslatedMessage id="examSessionCandidate.addDialog.rebookWithInvoice" />
                  </Typography>
                  <Switch
                    color="primary"
                    checked={rebookWithInvoice}
                    onChange={() => setRebookWithInvoice(!rebookWithInvoice)}
                  ></Switch>
                </Box>
              </FormGridCell>
          </ListItem>
        </>
      }
      isOpen={true}
      onAccept={handleAccept}
      onCancel={decline}
      title={<TranslatedMessage id="examSessionCandidate.rebook" />}
    />
  );
};

export default ExamSessionCandidateModuleRebookDialog;
